<template>
  <div class="read-banner">
    <h2 class="title">
      <a v-if="isImgLoaded && mode === 'LATEST'" :style="textStyle" class="mode-name" @click="changeMode">
        {{ $t('ARTICLE.THE_LATEST_ARTICLES') }}
      </a>
      <a v-else-if="isImgLoaded && mode === 'RECOMMEND'" :style="textStyle" class="mode-name" @click="changeMode">
        {{ $t('ARTICLE.THE_RECOMMEND_ARTICLES') }}
      </a>
      <a v-if="!isImgLoaded" :style="coverInOutStyle" class="holder skeleton-screen" />
    </h2>
    <div class="banners">
      <a class="banner top" @click="goToArticleById(top)">
        <div ref="top" :data-src="''" :data-deafault-src="'/img/cover-social/read.png'"
             :class="{'skeleton-cover2': !top.isImgLoaded}" :style="coverInOutStyle" class="cover"
        >
          <div :class="{ mask: top.isImgLoaded === 'success' }">
            <!--  -->
          </div>
        </div>
        <div v-show="top.isImgLoaded === 'success'" class="info">
          <div class="subject">
            {{ top.subject }}
          </div>
          <div class="publish">
            <span class="date">
              {{ top.displayPublishDate }}
            </span>
            <span class="dot">
              ⋅
            </span>
            <span class="author">
              {{ top.displayAuthorsText }}
            </span>
          </div>
        </div>
      </a>
      <a class="banner left" @click="goToArticleById(left)">
        <div ref="left" :data-src="''" :data-deafault-src="'/img/cover-social/read.png'"
             :class="{'skeleton-cover2': !left.isImgLoaded}" :style="coverInOutStyle" class="cover"
        >
          <div :class="{ mask: left.isImgLoaded === 'success' }">
            <!--  -->
          </div>
        </div>
        <div v-show="left.isImgLoaded === 'success'" class="info">
          <div class="subject">
            {{ left.subject }}
          </div>
          <div class="publish">
            <span class="date">
              {{ left.displayPublishDate }}
            </span>
            <span class="dot">
              ⋅
            </span>
            <span class="author">
              {{ left.displayAuthorsText }}
            </span>
          </div>
        </div>
      </a>
      <a class="banner middle" @click="goToArticleById(middle)">
        <div ref="middle" :data-src="''" :data-deafault-src="'/img/cover-social/read.png'"
             :class="{'skeleton-cover2': !middle.isImgLoaded}" :style="coverInOutStyle" class="cover"
        >
          <div :class="{ mask: middle.isImgLoaded === 'success' }">
            <!--  -->
          </div>
        </div>
        <div v-show="middle.isImgLoaded === 'success'" class="info">
          <div class="subject">
            {{ middle.subject }}
          </div>
          <div class="publish">
            <span class="date">
              {{ middle.displayPublishDate }}
            </span>
            <span class="dot">
              ⋅
            </span>
            <span class="author">
              {{ middle.displayAuthorsText }}
            </span>
          </div>
        </div>
      </a>
      <a class="banner right" @click="goToArticleById(right)">
        <div ref="right" :data-src="''" :data-deafault-src="'/img/cover-social/read.png'"
             :class="{'skeleton-cover2': !right.isImgLoaded}" :style="coverInOutStyle" class="cover"
        >
          <div :class="{ mask: right.isImgLoaded === 'success' }">
            <!--  -->
          </div>
        </div>
        <div v-show="right.isImgLoaded === 'success'" class="info">
          <div class="subject">
            {{ right.subject }}
          </div>
          <div class="publish">
            <span class="date">
              {{ right.displayPublishDate }}
            </span>
            <span class="dot">
              ⋅
            </span>
            <span class="author">
              {{ right.displayAuthorsText }}
            </span>
          </div>
        </div>
      </a>
    </div>
    <div style="clear: both;">
      <!--  -->
    </div>
  </div>
</template>

<script>
import CoverLazyLoader from '@/directives/CoverLazyLoader'
import ArticleService from '@/assets/services/ArticleService'

export default {
  name: 'ReadBanner',
  components: {},
  directives: {
    CoverLazyLoader
  },
  props: {},
  data() {
    return {
      isImgLoaded: undefined,
      mode: 'RECOMMEND', // LATEST, RECOMMEND, RANDOM
      postionList: ['top', 'left', 'middle', 'right'],
      top: {},
      left: {},
      middle: {},
      right: {}
    }
  },
  computed: {
    coverInOutStyle() {
      return this.isImgLoaded === 'success'
        ? { transition: 'opacity 0.2s ease-in', opacity: 1 }
        : this.isImgLoaded === 'replacing' ? { transition: 'all 0.2s ease-out', opacity: 0 } : {} // default
    },
    textStyle() {
      return this.isImgLoaded === 'success' ? { transition: 'opacity 0.2s ease-in', opacity: 1 } : { opacity: 0 }
    }
  },
  created() {},
  mounted() {
    this.initBannerArticles()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.checkImage)
  },
  methods: {
    async initBannerArticles() {
      this.isImgLoaded = undefined // init placeholder
      const articleList = await this.getBannerArticles()
      if (articleList && articleList.length === 4) {
        this.top = articleList[0]
        this.left = articleList[1]
        this.middle = articleList[2]
        this.right = articleList[3]
        window.addEventListener('scroll', this.checkImage)
        this.checkImage()
      } else {
        // Get banner api error
        // continually skeleton
        if (this.mode !== 'LATEST') {
          this.changeMode()
        }
      }
    },
    async getBannerArticles() {
      let params = {
        per_page: 4,
        page: 1
      }
      let articles = []
      if (this.mode === 'LATEST') {
        params.sort = '-published_at'
        articles = await ArticleService.getArticles(params)
      } else if (this.mode === 'RANDOM') {
        articles = await ArticleService.getArticleByRecommend(params)
      } else {
        // ASSIGNED
        // const ARTICLE_ID_ARRAY = [
        //   '8c18950e-3cf7-4eb8-8117-38b7c7ad2ba5', // 18777
        //   '8c189cca-b705-41ba-a91c-89e23b99ee09', // 23916
        //   '8c189db8-e8ec-4b10-a7f0-d447df87d719', // 27903
        //   '8c189cee-407c-4824-802b-019997c0c07a' // 24855
        // ]
        // params.q = {
        //   id: ARTICLE_ID_ARRAY
        // }
        // articles = await ArticleService.getArticles(params)
        // if (articles) {
        //   articles.data.sort((a, b) => {
        //     return ARTICLE_ID_ARRAY.indexOf(a.id) - ARTICLE_ID_ARRAY.indexOf(b.id)
        //   })
        // }

        // PINNED
        params.q = {
          pinned: '1'
        }
        articles = await ArticleService.getArticles(params)
        if (articles) {
          articles.data.sort((a, b) => {
            return a.sort - b.sort
          })
        }
      }
      if (articles) {
        articles.data.forEach(article => {
          article.displayPublishDate = article['published_at'].split(' ')[0]
          article.displayAuthorsText = article['authors'].map(item => item.name).join(', ')
          article.isImgLoaded = false
        })
        return articles.data
      } else {
        return []
      }
    },
    async loadImage(imgItem) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.src = imgItem.src
        img.onload = () => {
          resolve({
            position: imgItem.position,
            src: img.src
          })
        }
        img.onerror = err => {
          console.error('Load banner image error.', err)
          resolve({
            position: imgItem.position,
            src: '/img/cover-social/read.png'
          })
        }
      })
    },
    isInViewpoint(element) {
      // const windowHeight = window.innerHeight || document.documentElement.clientHeight
      // const windowPageYOffset = window.pageYOffset
      // const bundle = element.getBoundingClientRect()
      if (element &&
        (window.innerHeight || document.documentElement.clientHeight) + window.pageYOffset >
        element.getBoundingClientRect().top
      ) {
        return true
      } else {
        return false // pass
      }
    },
    async checkImage() {
      let imgloadList = []
      let imgloadedList = []

      this.postionList.forEach(position => {
        if (this.isInViewpoint(this.$refs[position])) {
          if (!this.$refs[position].style.backgroundImage) {
            imgloadList.push({ 'position': position, 'src': this[position].cover })
            this[position].isImgLoaded = 'replacing'
          }
          imgloadedList.push(true)
        }
      })
      const promiseList = imgloadList.map(imgItem => this.loadImage(imgItem))
      const results = await Promise.all(promiseList)
      if (!this.isImgLoaded) {
        this.isImgLoaded = 'replacing' // setting title at first time
      }

      // $nextTick callback only updated DOM, but seems not to style transition trigger
      // use setTimeout make sure style transition occur
      setTimeout(() => {
        results.forEach(obj => {
          if (obj.position && obj.src) {
            this.$refs[obj.position].style.backgroundImage = `url(${obj.src})`
            this[obj.position].isImgLoaded = 'success'
          }
        })
        this.isImgLoaded = 'success' // setting title at first time
      }, 200)
      if (imgloadedList.length === 4) {
        window.removeEventListener('scroll', this.checkImage)
      }
    },
    changeMode() {
      this.mode = this.mode === 'RECOMMEND' ? 'LATEST' : 'RECOMMEND'
      this.postionList.forEach(position => {
        this.$refs[position].style.backgroundImage = ''
        this[position] = {}
      })
      this.initBannerArticles()
    },
    goToArticleById(article) {
      if (article && article.id) {
        this.$router.push({ name: 'articleById', params: { id: article.id } })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.read-banner {
  // margin-bottom: 24px;
  .title {
    height: 32px;
    margin-top: 24px;
    margin-bottom: 24px;

    font-size: 20px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.6;
    letter-spacing: normal;
    color: $grey-50;
    .mode-name {
      cursor: pointer;
      user-select: none;
      text-decoration: none;
    }
    .holder {
      display: inline-block;
      height: 32px;
      width: 240px;
      // border-radius: 12px;
      // border: solid 1px #a10903;
      background-color: $grey-ec;
    }
  }
  .banners {
    display: block;
    margin: 0 -12px;
  }
  .banner {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 390px;
    margin: 0 12px 24px; // 0 12px 24px 12px
    border-radius: 12px;
    cursor: pointer;
    .mask {
      height: 100%;
      width: 100%;
      border-radius: 12px;
      background-color: rgba(0, 0, 0, 0.27);
    }
    .cover {
      width: 100%;
      height: 390px;
      border-radius: 12px;
      background-color: $grey-ec;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
    .info {
      position: absolute;
      left: 0px;
      bottom: 0px;
      width: 100%;
      padding: 24px;
      font-weight: 500;
      color: white;
      .subject {
        width: 100%;
        max-height: 80px;
        font-size: 24px;
        line-height: 1.63; // 39.12px

        @include ellipsis-with-lines(3);
      }
      .publish {
        width: 100%;
        max-height: 32px;
        font-size: 14px;
        line-height: 1.64;

        white-space: nowrap; // Don't use with display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    &.top {
      width: calc(100% - 24px);
    }
    &.left,
    &.middle,
    &.right {
      float: left;
      width: calc(33.33% - 24px);
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  .read-banner {
    .banners {
      margin: 0;
    }
    .banner {
      height: 300px;
      .cover {
        height: 300px;
      }
      .info {
        .subject {
          max-height: 64px;
          font-size: 20px;
          line-height: 1.6;
        }
        .publish {
          max-height: 18px;
          font-size: 12px;
        }
      }
      &.top,
      &.left,
      &.right,
      &.middle {
        width: 100%;
        margin: 0 0 24px;
      }
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .read-banner {
    .title {
      margin-bottom: 16px;
    }
    .banners {
      margin: 0;
    }
    .banner {
      .info {
        .subject {
          max-height: 64px;
          font-size: 20px;
          line-height: 1.6;
        }
        .publish {
          max-height: 18px;
          font-size: 12px;
        }
      }
      &.top,
      &.left {
        height: 300px;
        width: 100%;
        margin: 0 0 24px;
        .cover {
          height: 300px;
        }
      }
      &.middle {
        margin: 0 24px 24px 0;
      }
      &.right {
        margin: 0 0 24px 0;
      }
      &.middle,
      &.right {
        float: left;
        height: 210px;
        width: calc(50% - 12px);
        .cover {
          height: 110px;
        }
        .info {
          padding: 0px;
          top: 110px;
          font-weight: 500;
          line-height: 1.6;
          word-wrap: break-word;
          .subject {
            max-height: 64px;
            margin-top: 16px;
            margin-bottom: 4px;
            color: $grey-50;
            font-size: 20px;

            @include ellipsis-with-lines(2);
          }
          .publish {
            height: 20px;
            color: $grey-9b;
            font-size: 12px;

            white-space: nowrap; // Don't use with display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
</style>
